module.exports = __webpack_public_path__ + "static/media/demo_image.cf8a3068.jpg";